import { PdfTablePropsColumn, PdfTablePropsRow } from '../PdfComponents/PdfTable';
import { taytanFormatNumberToString } from '../../../utils/mathUtils';

const columns: Array<PdfTablePropsColumn> = [
    { title: 'Debit', fieldName: 'debit' },
    { title: 'Credit', fieldName: 'credit' },
    { title: 'Amount', fieldName: 'amount' },
    { title: 'Currency', fieldName: 'currency' }
];

export const getCreditDebitPdfTableData = (props: {
    source: string;
    target: string;
    amount: number;
    currencyCode: string;
}): { columns: PdfTablePropsColumn[]; rows: PdfTablePropsRow[]; summaryLine: {} } => {
    const { source, target, amount, currencyCode } = props;
    const rows: Array<PdfTablePropsRow> = [
        {
            debit: source,
            credit: target,
            amount: taytanFormatNumberToString(amount),
            currency: currencyCode
        }
    ];

    const summaryLine = {
        debit: 'Total',
        amount: taytanFormatNumberToString(amount),
        currency: currencyCode
    };

    return { columns, rows, summaryLine };
};
